(() => {
  'use strict';

  if (window.BabyGamblingWishlistLoaded) return;
  window.BabyGamblingWishlistLoaded = true;

  const STORAGE_KEY = 'bg_dawn_wishlist_v1';
  const configNode = document.getElementById('wishlist-config');
  let config = {};

  try {
    config = configNode ? JSON.parse(configNode.textContent) : {};
  } catch (error) {
    console.warn('Wishlist configuration could not be read.', error);
  }

  const labels = Object.assign(
    {
      add: 'Add to wishlist',
      remove: 'Remove from wishlist',
      wishlist: 'Wishlist',
      items: 'items',
      chooseOptions: 'Choose options',
      loading: 'Loading wishlist…',
      error: 'Some wishlist products could not be loaded. Please refresh the page.'
    },
    config.labels || {}
  );

  const heartIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path class="wishlist-heart-fill" d="M12 20.6 3.5 12.2a5.5 5.5 0 0 1 7.8-7.8L12 5.1l.7-.7a5.5 5.5 0 1 1 7.8 7.8L12 20.6Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  const closeIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>`;

  const imageIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M4 5.5h16v13H4zM4 15l4.5-4.5 3.5 3 2-2 6 5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
      <circle cx="15.5" cy="9" r="1.5" fill="currentColor"/>
    </svg>`;

  let memoryItems = [];

  function normalizeItems(value) {
    if (!Array.isArray(value)) return [];

    const handles = value
      .map((item) => (typeof item === 'string' ? item : item && item.handle))
      .map((handle) => String(handle || '').trim())
      .filter(Boolean);

    return Array.from(new Set(handles));
  }

  function getItems() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      memoryItems = normalizeItems(parsed);
    } catch (error) {
      // Private browsing or strict cookie settings may block localStorage.
    }

    return memoryItems.slice();
  }

  function setItems(items) {
    memoryItems = normalizeItems(items);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryItems));
    } catch (error) {
      // The current tab still works by using the in-memory copy.
    }

    updateInterface();
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { handles: memoryItems.slice() } })
    );
  }

  function has(handle) {
    return getItems().includes(handle);
  }

  function add(handle) {
    if (!handle || has(handle)) return;
    setItems([...getItems(), handle]);
  }

  function remove(handle) {
    setItems(getItems().filter((item) => item !== handle));
  }

  function toggle(handle) {
    if (has(handle)) remove(handle);
    else add(handle);
  }

  function productHandleFromUrl(urlValue) {
    if (!urlValue) return '';

    try {
      const url = new URL(urlValue, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function rootUrl(path) {
    const root = String(config.root || '/');
    return `${root.endsWith('/') ? root : `${root}/`}${String(path || '').replace(/^\//, '')}`;
  }

  function makeHeartButton(handle, type) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = type === 'product' ? 'wishlist-product-button' : 'wishlist-card-button';
    button.dataset.wishlistToggle = '';
    button.dataset.wishlistHandle = handle;
    if (type === 'card') button.dataset.wishlistCardButton = '';
    if (type === 'product') button.dataset.wishlistProductButton = '';
    button.innerHTML = heartIcon;

    if (type === 'product') {
      const text = document.createElement('span');
      text.dataset.wishlistButtonText = '';
      button.appendChild(text);
    }

    return button;
  }

  function syncToggleButtons() {
    const items = getItems();

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = items.includes(button.dataset.wishlistHandle);
      const text = active ? labels.remove : labels.add;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', text);
      button.setAttribute('title', text);

      const textNode = button.querySelector('[data-wishlist-button-text]');
      if (textNode && textNode.textContent !== text) textNode.textContent = text;
    });
  }

  function syncCounts() {
    const count = getItems().length;

    document.querySelectorAll('[data-wishlist-count]').forEach((bubble) => {
      const displayedCount = count > 99 ? '99+' : String(count);
      if (bubble.textContent !== displayedCount) bubble.textContent = displayedCount;
      if (bubble.hidden !== (count === 0)) bubble.hidden = count === 0;
    });

    document.querySelectorAll('[data-wishlist-header]').forEach((link) => {
      link.setAttribute('aria-label', `${labels.wishlist}, ${count} ${labels.items}`);
    });
  }

  function ensureCardButtons(scope = document) {
    scope.querySelectorAll('.card-wrapper').forEach((wrapper) => {
      if (wrapper.querySelector('[data-wishlist-card-button]')) return;

      const productLink = Array.from(wrapper.querySelectorAll('a[href*="/products/"]')).find(
        (link) => productHandleFromUrl(link.href)
      );
      const handle = productLink ? productHandleFromUrl(productLink.href) : '';
      const mount = wrapper.querySelector('.card__inner') || wrapper.querySelector('.card');

      if (handle && mount) mount.appendChild(makeHeartButton(handle, 'card'));
    });
  }

  function ensureProductButton() {
    if (document.querySelector('[data-wishlist-product-button]')) return;

    const handle = productHandleFromUrl(window.location.href);
    const productInfo = document.querySelector('.product__info-container');
    if (!handle || !productInfo) return;

    const button = makeHeartButton(handle, 'product');
    const form = productInfo.querySelector('product-form') ||
      productInfo.querySelector('form[action*="/cart/add"]');

    if (form) form.insertAdjacentElement('afterend', button);
    else productInfo.appendChild(button);
  }

  function updateInterface() {
    syncToggleButtons();
    syncCounts();
    renderAllWishlistPages();
  }

  function decodeHtml(value) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = String(value || '');
    return textArea.value;
  }

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    const safeNumber = Number(number);
    if (!Number.isFinite(safeNumber)) return '0';

    const parts = (safeNumber / 100).toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
  }

  function formatMoney(cents) {
    const value = Number(cents || 0);
    const format = decodeHtml(config.moneyFormat || '${{amount}}');
    const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!placeholder) return `${(value / 100).toFixed(2)}`;

    let amount;
    switch (placeholder[1]) {
      case 'amount_no_decimals':
        amount = formatWithDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = formatWithDelimiters(value, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        amount = formatWithDelimiters(value, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        amount = formatWithDelimiters(value, 0, ' ', '.');
        break;
      default:
        amount = formatWithDelimiters(value, 2, ',', '.');
    }

    return format.replace(placeholder[0], amount).replace(/<[^>]*>/g, '');
  }

  async function fetchProduct(handle) {
    const response = await fetch(rootUrl(`products/${encodeURIComponent(handle)}.js`), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      const error = new Error(`Product ${handle} returned ${response.status}`);
      error.status = response.status;
      throw error;
    }

    return response.json();
  }

  function productImageUrl(product) {
    const source = typeof product.featured_image === 'string'
      ? product.featured_image
      : product.featured_image && product.featured_image.src;

    if (!source) return '';
    const separator = source.includes('?') ? '&' : '?';
    return `${source}${separator}width=720`;
  }

  function createWishlistCard(product, page) {
    const item = document.createElement('li');
    const article = document.createElement('article');
    const imageLink = document.createElement('a');
    const productUrl = product.url || rootUrl(`products/${product.handle}`);
    const imageUrl = productImageUrl(product);

    item.className = 'wishlist-grid-item';
    article.className = 'wishlist-grid-card';
    imageLink.className = 'wishlist-card-image-wrap';
    imageLink.href = productUrl;
    imageLink.setAttribute('aria-label', product.title);

    if (imageUrl) {
      const image = document.createElement('img');
      image.className = 'wishlist-card-image';
      image.src = imageUrl;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 720;
      image.height = 900;
      imageLink.appendChild(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'wishlist-card-placeholder';
      placeholder.innerHTML = imageIcon;
      imageLink.appendChild(placeholder);
    }

    const removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'wishlist-remove-button';
    removeButton.dataset.wishlistRemove = '';
    removeButton.dataset.wishlistHandle = product.handle;
    removeButton.setAttribute('aria-label', page.dataset.removeLabel || labels.remove);
    removeButton.title = page.dataset.removeLabel || labels.remove;
    removeButton.innerHTML = closeIcon;

    const info = document.createElement('div');
    info.className = 'wishlist-card-info';

    if (page.dataset.showVendor === 'true' && product.vendor) {
      const vendor = document.createElement('p');
      vendor.className = 'wishlist-card-vendor';
      vendor.textContent = product.vendor;
      info.appendChild(vendor);
    }

    const title = document.createElement('a');
    title.className = 'wishlist-card-title';
    title.href = productUrl;
    title.textContent = product.title;
    info.appendChild(title);

    const price = document.createElement('div');
    price.className = 'wishlist-card-price';
    const currentPrice = document.createElement('span');
    currentPrice.textContent = formatMoney(product.price);
    price.appendChild(currentPrice);

    if (product.compare_at_price && product.compare_at_price > product.price) {
      const comparePrice = document.createElement('span');
      comparePrice.className = 'wishlist-card-price-compare';
      comparePrice.textContent = formatMoney(product.compare_at_price);
      price.appendChild(comparePrice);
    }

    info.appendChild(price);

    const actions = document.createElement('div');
    actions.className = 'wishlist-card-actions';
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const availableVariant = variants.find((variant) => variant.available) || variants[0];

    if (product.available && availableVariant && variants.length === 1) {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = rootUrl('cart/add');

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = availableVariant.id;

      const quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.value = '1';

      const submit = document.createElement('button');
      submit.type = 'submit';
      submit.className = 'button button--primary';
      submit.textContent = page.dataset.addLabel || 'Add to cart';

      form.append(input, quantity, submit);
      actions.appendChild(form);
    } else if (product.available && variants.length > 1) {
      const choose = document.createElement('a');
      choose.className = 'button button--secondary';
      choose.href = productUrl;
      choose.textContent = page.dataset.chooseLabel || labels.chooseOptions;
      actions.appendChild(choose);
    } else {
      const unavailable = document.createElement('button');
      unavailable.type = 'button';
      unavailable.className = 'button button--secondary';
      unavailable.disabled = true;
      unavailable.textContent = page.dataset.unavailableLabel || 'Sold out';
      actions.appendChild(unavailable);
    }

    info.appendChild(actions);
    article.append(imageLink, removeButton, info);
    item.appendChild(article);
    return item;
  }

  async function renderWishlistPage(page) {
    if (page.dataset.wishlistRendering === 'true') return;

    const signature = getItems().join('|');
    if (page.dataset.wishlistSignature === signature) return;

    const grid = page.querySelector('[data-wishlist-grid]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const loading = page.querySelector('[data-wishlist-loading]');
    const errorState = page.querySelector('[data-wishlist-error]');
    const handles = getItems();

    page.dataset.wishlistRendering = 'true';
    page.setAttribute('aria-busy', 'true');
    grid.hidden = true;
    empty.hidden = true;
    loading.hidden = handles.length === 0;
    errorState.hidden = true;

    if (handles.length === 0) {
      grid.replaceChildren();
      loading.hidden = true;
      empty.hidden = false;
      page.dataset.wishlistSignature = signature;
      page.dataset.wishlistRendering = 'false';
      page.removeAttribute('aria-busy');
      return;
    }

    const results = await Promise.allSettled(handles.map(fetchProduct));
    const products = [];
    const missingHandles = [];
    let hasTemporaryError = false;

    results.forEach((result, index) => {
      if (result.status === 'fulfilled') products.push(result.value);
      else if (result.reason && result.reason.status === 404) missingHandles.push(handles[index]);
      else hasTemporaryError = true;
    });

    if (missingHandles.length) {
      memoryItems = handles.filter((handle) => !missingHandles.includes(handle));
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryItems));
      } catch (storageError) {
        // Continue rendering valid products.
      }
      syncCounts();
      syncToggleButtons();
    }

    grid.replaceChildren(...products.map((product) => createWishlistCard(product, page)));
    loading.hidden = true;
    grid.hidden = products.length === 0;
    empty.hidden = products.length !== 0 || hasTemporaryError;
    errorState.hidden = !hasTemporaryError;
    page.dataset.wishlistSignature = getItems().join('|');
    page.dataset.wishlistRendering = 'false';
    page.removeAttribute('aria-busy');
  }

  function renderAllWishlistPages() {
    document.querySelectorAll('[data-wishlist-page]').forEach((page) => {
      renderWishlistPage(page).catch((error) => {
        console.warn('Wishlist page could not be rendered.', error);
        const loading = page.querySelector('[data-wishlist-loading]');
        const errorState = page.querySelector('[data-wishlist-error]');
        if (loading) loading.hidden = true;
        if (errorState) errorState.hidden = false;
        page.dataset.wishlistRendering = 'false';
        page.removeAttribute('aria-busy');
      });
    });
  }

  function initializeUi(scope = document) {
    ensureCardButtons(scope);
    ensureProductButton();
    syncToggleButtons();
    syncCounts();
    renderAllWishlistPages();
  }

  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('[data-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggle(toggleButton.dataset.wishlistHandle);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      remove(removeButton.dataset.wishlistHandle);
    }
  }, true);

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      memoryItems = [];
      updateInterface();
    }
  });

  document.addEventListener('shopify:section:load', (event) => initializeUi(event.target));

  let observerQueued = false;
  const observer = new MutationObserver(() => {
    if (observerQueued) return;
    observerQueued = true;
    window.requestAnimationFrame(() => {
      initializeUi();
      observerQueued = false;
    });
  });

  function start() {
    initializeUi();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.DawnWishlist = { add, remove, toggle, has, items: getItems };
})();
